module.exports = __webpack_public_path__ + "static/media/1cent.b870167b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/coupures/1cent.png
// module id = 921
// module chunks = 0